import Mainlayout from "../components/layouts/index";
import CrmMainlayout from "../components/layouts/crm-sidebar/index";
import GlobalAdminLayout from "../components/layouts/global-admin-sidebar/index";
import UnifyLayout from "../components/layouts/unify-sidebar/index";
import TrackLayout from "../components/layouts/track-sidebar/index";
import AutomateLayout from "../components/layouts/automate-sidebar/index";
import CxoLayout from "../components/layouts/cxo-sidebar/index";
import ComingSoonPage from "../components/layouts/coming-soon-page";
import { Navigate } from "react-router-dom";
import {
  Scan,
  Tag,
  Shield,
  RefreshCw,
  Settings as SettingsIcon,
  Activity,
  Code2,
  Zap,
  MousePointerClick,
  Sparkles,
  FileText,
  Plug,
  ClipboardList,
  Target,
  TrendingUp,
  FileBarChart2,
  ShieldCheck,
} from "lucide-react";
import GlobalAdminBusinesses from "../views/global-admin-pages/businesses";
import MyCampaign from "../views/marketing-pages/campaign";
import WhatsAppInbox from "../views/marketing-pages/chat-box";
import CPaaSDashboard from "../views/marketing-pages/cloud-dashboard";
import DashboardOverview from "../views/marketing-pages/dashboard";
import LandingPage from "../views/marketing-pages/landing";
import GlobalAdminResellers from "../views/global-admin-pages/resellers";
import GlobalAdminTransactionalReports from "../views/global-admin-pages/reports";
import MessagingRatePage from "../views/marketing-pages/settings";
import Dashboard from "../views/marketing-pages/view-campaign";
import WalletScreen from "../views/marketing-pages/wallet";
import TransactionalMessages from "../views/marketing-pages/transactional-messages";
import WhatsAppSetup from "../views/marketing-pages/channels/whatsapp";
import EmailDashboard from "../views/marketing-pages/channels/email";
import RcsSetupPage from "../views/marketing-pages/channels/rcs/rcs";
import VoiceCommunications from "../views/marketing-pages/channels/voice";
import WebChat from "../views/marketing-pages/channels/web-chat";
import TelegramBot from "../views/marketing-pages/channels/telegram";
import UseCases from "../views/marketing-pages/use-cases";
import AnimatedConnectionFlow from "../views/marketing-pages/connectors";
import SourcesDashboard from "../views/marketing-pages/connectors/connector/sources";
import DestinationsDashboard from "../views/marketing-pages/connectors/connector/destinations";
import AudienceDashboard from "../views/marketing-pages/audience";
import NewAudience from "../views/marketing-pages/audience/new-audience"
import Contact from "../views/marketing-pages/contact";
import AuthGuard from "../utils/auth-guard/route-guard";
import SMSCampaignFlow from "../views/marketing-pages/create-campaign";
import VoiceSetup from "../views/marketing-pages/channels/voice/voice-step";
import MakeOutboundCall from "../views/marketing-pages/channels/voice/call";
import NewConnectionFlow from "../components/marketing/connector/connector";
import LeadsPage from "../views/marketing-pages/leads";
import AllLeadsPage from "../views/marketing-pages/leads/all-leads";
import CrmContacts from "../views/crm-pages/contacts";
import ContactDetail from "../views/crm-pages/contacts/details";

import CPaaSDashboardRedirect from "../views/marketing-pages/cloud-dashboard/cpas-redirect";
import ConvoAi from "../views/crm-pages/convoai";
import CrmDashboard from "../views/crm-pages/home";
import ConversationDashboard from "../views/crm-pages/conversation";
import Subscription from "../unsubscribe";
import Customers from "../views/crm-pages/customers";
import CustomerDetail from "../views/crm-pages/customers/details/customer_details";
import TemplateCreator from "../views/marketing-pages/templates";
import AllBotsList from "../views/convoauto-pages/bot-studio";
import BotBuilderPage from "../views/convoauto-pages/bot-studio/create-builder";
import CustomerJourneyBuilderPage from "../views/convoauto-pages/bot-studio/customer-journey/builder-page";
import ExecutionsPage from "../views/convoauto-pages/bot-studio/executions";
import AutomateOverview from "../views/convoauto-pages/overview";
import AllTraits from "../views/unify-pages/traits/all-traits";
import NewTrait from "../views/unify-pages/traits/new-trait";
import CategoryTraitsPage from "../views/unify-pages/traits/category-traits-page";
import Tickets from "../views/crm-pages/ticket";
import Team from "../views/crm-pages/team";
import SMSCampaignReport from "./small-wrapper";
import MarketingAnalytics from "../views/crm-pages/analytics";
import ArchivedChat from "../views/crm-pages/conversation/archived";
import Segments from "../views/marketing-pages/segments";
import UnifyPage from "../views/unify-pages/unify";
import UnifySetupPage from "../views/unify-pages/unify/setup";
import UnifiedProfilePage from "../views/unify-pages/unify/profile";
import UnifyMergeLogsPage from "../views/unify-pages/unify/merge-logs";

import SingleTicket from "../views/crm-pages/ticket/single-ticket";
import CDPOverview from "../views/unify-pages/overview";
import ProfileExplorer from "../views/unify-pages/profile-explorer";
import AudienceStudio from "../views/unify-pages/audiences";
import Businesses from "../views/crm-pages/businesses";
import Calls from "../views/crm-pages/calls";
import GlobalAdminDashboard from "../views/global-admin-pages/dashboard";
import DealsDashboard from "../views/crm-pages/deals";
import AttributionPage from "../views/track-pages/attribution";
import LiveEventStreamPage from "../views/track-pages/live-event-stream";
import TrackSetupGuide from "../views/track-pages/setup-guide";
import CXODashboard from "../views/convocxo-pages/cxo-dashboard";
import AdsCreativePerformance from "../views/convocxo-pages/ads-creative-performance";
import CampaignsList from "../views/convocxo-pages/campaigns/campaigns-list";
import CampaignDetail from "../views/convocxo-pages/campaigns/campaign-detail";
import AdsetDetail from "../views/convocxo-pages/campaigns/adset-detail";
import AdCreativeDetail from "../views/convocxo-pages/campaigns/ad-detail";
import Integrations from "../views/crm-pages/integrations";
import SupportBotKnowledge from "../views/crm-pages/support-bot/knowledge";
import SupportBotApprovals from "../views/crm-pages/support-bot/approvals";
import SupportBotMySubmissions from "../views/crm-pages/support-bot/my-submissions";
import SupportBotSetup from "../views/crm-pages/support-bot/setup";
import { SupportAgentRoute } from "../views/crm-pages/support-bot/shared";
import ResellerLayout from "../components/layouts/reseller-sidebar/index";
import ResellerDashboard from "../views/reseller-pages/dashboard";
import ResellerPartnerConsole from "../views/reseller-pages/partner-console";
import ResellerNewClient from "../views/reseller-pages/new-client";
import GlobalAdminConvoMarketing from "../views/global-admin-pages/convo-marketing";

// ========== ROUTING CONFIG ========== //
const AppRoutes = [
  // { path: "cpas", element: <ConvoHubPlatform /> },
  { path: "cpas", element: <CPaaSDashboard /> },
  { path: "/subscription", element: <Subscription /> },
  {
    path: "/",
    element: <LandingPage />,
  },
  { path: "ticketing/:ticketId", element: <SingleTicket /> },
  {
    path: "/messaging",
    element: <WhatsAppInbox />,
  },

  {
    path: "/",
    element: (
      <AuthGuard>
        <Mainlayout />
      </AuthGuard>
    ),

    children: [
      { path: "/campaigns/create", element: <SMSCampaignFlow /> },
      { path: "cpas-dashboard", element: <CPaaSDashboardRedirect /> },
      { path: "dashboard", element: <DashboardOverview /> },
      { path: "campaign", element: <MyCampaign /> },
      { path: "view-campaign", element: <Dashboard /> },
      { path: "journey", element: <AllBotsList /> },
      { path: "journey/new/:id?", element: <BotBuilderPage /> },
      { path: "campaign-report/:id", element: <SMSCampaignReport /> },
      { path: "whatsapp-setup", element: <WhatsAppSetup /> },
      { path: "templates", element: <TemplateCreator /> },
      { path: "email", element: <EmailDashboard /> },
      { path: "rcs-setup", element: <RcsSetupPage /> },
      { path: "voice", element: <VoiceCommunications /> },
      { path: "voice-setup", element: <VoiceSetup /> },
      { path: "webchat-setup", element: <WebChat /> },
      { path: "telegram-setup", element: <TelegramBot /> },
      { path: "settings", element: <MessagingRatePage /> },
      { path: "wallet", element: <WalletScreen /> },
      { path: "transactional-messages", element: <TransactionalMessages /> },
      // { path: "cdp", element: <CDP /> },
      { path: "use-cases", element: <UseCases /> },
      { path: "audience", element: <AudienceDashboard /> },
      { path: "audience/new", element: <NewAudience /> },
      { path: "contact", element: <Contact /> },
      { path: "contact", element: <Contact /> },
      { path: "make/call", element: <MakeOutboundCall /> },
      { path: "segments", element: <Segments /> },
    ],
  },


  {
    path: "/",
    element: (
      <AuthGuard>
        <CrmMainlayout />
      </AuthGuard>
    ),

    children: [
      { path: "crm/dashboard", element: <CrmDashboard /> },
      { path: "convoAi", element: <ConvoAi /> },
      { path: "chats/:phone?", element: <ConversationDashboard /> },
      { path: "archive/chats", element: <ArchivedChat /> },
      { path: "cdp", element: <CDPOverview /> },
      { path: "leads", element: <LeadsPage /> },
      { path: "leads/all", element: <AllLeadsPage /> },
      { path: "customers", element: <Customers /> },
      { path: "customers/:id", element: <CustomerDetail /> },
      { path: "ticketing", element: <Tickets /> },
      { path: "team", element: <Team /> },
      { path: "crm/contact", element: <CrmContacts /> },
      { path: "contact/details", element: <ContactDetail /> },
      { path: "analytics", element: <MarketingAnalytics /> },
      { path: "businesses", element: <Businesses /> },
      { path: "calls", element: <Calls /> },
      { path: "deals", element: <DealsDashboard /> },
      { path: "integrations", element: <Integrations /> },
      { path: "support-bot/knowledge", element: <SupportAgentRoute screen="Knowledge"><SupportBotKnowledge /></SupportAgentRoute> },
      { path: "support-bot/approvals", element: <SupportAgentRoute screen="Approvals"><SupportBotApprovals /></SupportAgentRoute> },
      { path: "support-bot/my-submissions", element: <SupportAgentRoute screen="My Submissions"><SupportBotMySubmissions /></SupportAgentRoute> },
      { path: "support-bot/setup", element: <SupportAgentRoute screen="Setup"><SupportBotSetup /></SupportAgentRoute> },
      { path: "traits", element: <AllTraits /> },
      { path: "traits/new", element: <NewTrait /> },
      // Alias — the Instagram OAuth callback (instagram.postman_collection.json)
      // redirects to `{fe_portal_uri}/settings/integrations?instagram=...`,
      // a different path than this app's own /integrations route. Mounting
      // the same page here too means the redirect lands correctly either way.
      { path: "settings/integrations", element: <Integrations /> },
    ],
  },

  {
    path: "/",
    element: (
      <AuthGuard>
        <GlobalAdminLayout />
      </AuthGuard>
    ),

    children: [
      { path: "global-admin/dashboard", element: <GlobalAdminDashboard /> },
      { path: "global-admin/businesses", element: <GlobalAdminBusinesses /> },
      { path: "global-admin/resellers", element: <GlobalAdminResellers /> },
      { path: "global-admin/reports", element: <GlobalAdminTransactionalReports /> },
      { path: "global-admin/convo-marketing", element: <GlobalAdminConvoMarketing /> },
    ],
  },

  {
    path: "/",
    element: (
      <AuthGuard>
        <ResellerLayout />
      </AuthGuard>
    ),
    children: [
      // Home is the Partner Console (client workspaces); Convo Marketing
      // pricing stays at reseller/dashboard (see
      // components/layouts/reseller-sidebar/sidebar.tsx).
      { path: "reseller/home", element: <ResellerPartnerConsole /> },
      { path: "reseller/clients/new", element: <ResellerNewClient /> },
      { path: "reseller/dashboard", element: <ResellerDashboard /> },
    ],
  },

  // Convo Unify — its own sidebar/area. Overview and Profiles reuse the
  // existing CDP Overview / Profile Explorer pages (moved here per the
  // "the overview will be the cdp overview dashboard ... profile explorer
  // for profile" ask); everything else is a placeholder until it's scoped.
  // NOTE: these pages are also still reachable from the CRM sidebar's CDP
  // menu — that backend-driven tree isn't something this frontend change
  // can safely remove items from without also updating the API, so for now
  // both paths work rather than truly "moving" them.
  {
    path: "/",
    element: (
      <AuthGuard>
        <UnifyLayout />
      </AuthGuard>
    ),

    children: [
      { path: "unify/overview", element: <CDPOverview /> },
      { path: "unify/dashboard", element: <UnifyPage /> },
      { path: "unify/setup", element: <UnifySetupPage /> },
      { path: "unify/unified-profiles/:id", element: <UnifiedProfilePage /> },
      { path: "unify/merge-logs", element: <UnifyMergeLogsPage /> },
      { path: "unify/profiles", element: <ProfileExplorer /> },
      { path: "unify/identity-resolution", element: <ComingSoonPage icon={Scan} title="Identity Resolution" /> },
      { path: "unify/traits/all", element: <AllTraits /> },
      { path: "unify/traits/new", element: <NewTrait /> },
      { path: "unify/traits/custom", element: <CategoryTraitsPage icon={Tag} title="Custom Traits" category="custom" /> },
      { path: "unify/traits/computed", element: <CategoryTraitsPage icon={Tag} title="Computed Traits" category="computed" /> },
      { path: "unify/traits/predictive", element: <CategoryTraitsPage icon={Tag} title="Predictive Traits" category="predictive" /> },
      { path: "unify/audiences", element: <AudienceStudio /> },
      { path: "unify/consent-privacy", element: <ComingSoonPage icon={Shield} title="Consent and Privacy" /> },
      { path: "unify/activation-sync", element: <ComingSoonPage icon={RefreshCw} title="Activation & Sync" /> },
      { path: "unify/settings", element: <ComingSoonPage icon={SettingsIcon} title="Unify Settings" /> },
    ],
  },

  // Convo Track — its own sidebar/area. Sources and Destinations reuse the
  // existing connector pages (moved here per the "sources and destinations
  // will be in track" ask); everything else is a placeholder. Same caveat
  // as Unify above re: the CRM sidebar's backend-driven nav tree.
  {
    path: "/",
    element: (
      <AuthGuard>
        <TrackLayout />
      </AuthGuard>
    ),

    children: [
      { path: "track/overview", element: <ComingSoonPage icon={Activity} title="Track Overview" /> },
      { path: "track/setup", element: <TrackSetupGuide /> },
      { path: "track/sources", element: <SourcesDashboard /> },
      { path: "track/live-event-stream", element: <LiveEventStreamPage /> },
      { path: "track/event-schema", element: <ComingSoonPage icon={Code2} title="Event Schema" /> },
      { path: "track/attribution", element: <AttributionPage /> },
      { path: "track/destinations", element: <DestinationsDashboard /> },
      { path: "track/settings", element: <ComingSoonPage icon={SettingsIcon} title="Track Settings" /> },
      { path: "track/connections/new", element: <NewConnectionFlow /> },
      { path: "track/connections", element: <AnimatedConnectionFlow /> },
    ],
  },

  // Convo Automate — its own sidebar/area, same pattern as Unify/Track.
  // "Workflows > All workflows" reuses the existing bot studio pages (moved
  // here from pages/bot-studio, the closest existing thing to a workflow
  // builder); everything else is a placeholder until it's scoped. NOTE: the
  // bot builder's own internal "New Bot"/edit flow still navigates to the
  // old /journey/new/:id? route (still reachable under the Marketing
  // sidebar) rather than an /automate-scoped equivalent — same
  // backend-nav-tree-style caveat as Unify/Track's moved pages, just for an
  // internal link instead of the CRM nav tree.
  {
    path: "/",
    element: (
      <AuthGuard>
        <AutomateLayout />
      </AuthGuard>
    ),

    children: [
      { path: "automate/overview", element: <AutomateOverview /> },
      { path: "automate/bot-studio", element: <AllBotsList /> },
      { path: "automate/bot-studio/customer-journey/new", element: <CustomerJourneyBuilderPage /> },
      { path: "automate/workflows/templates", element: <Navigate to="/automate/bot-studio?tab=templates" replace /> },
      { path: "automate/node-library/triggers", element: <ComingSoonPage icon={Zap} title="Triggers" /> },
      { path: "automate/node-library/actions", element: <ComingSoonPage icon={MousePointerClick} title="Actions" /> },
      { path: "automate/node-library/ai-nodes", element: <ComingSoonPage icon={Sparkles} title="AI Nodes" /> },
      { path: "automate/executions", element: <ExecutionsPage /> },
      { path: "automate/prompt-templates", element: <ComingSoonPage icon={FileText} title="Prompt Templates" /> },
      { path: "automate/moderation-queue", element: <ComingSoonPage icon={Shield} title="Moderation Queue" /> },
      { path: "automate/integrations", element: <ComingSoonPage icon={Plug} title="Integrations" /> },
    ],
  },

  // Convo CXO — its own sidebar/area, same pattern as Unify/Track/Automate.
  // Only one page exists today: the CXO Dashboard itself.
  {
    path: "/",
    element: (
      <AuthGuard>
        <CxoLayout />
      </AuthGuard>
    ),

    children: [
      { path: "cxo/overview", element: <CXODashboard /> },
      { path: "cxo/ads-creative-performance", element: <AdsCreativePerformance /> },
      { path: "cxo/campaigns", element: <CampaignsList /> },
      { path: "cxo/campaigns/:campaignId", element: <CampaignDetail /> },
      { path: "cxo/campaigns/:campaignId/adsets/:adsetId", element: <AdsetDetail /> },
      { path: "cxo/campaigns/:campaignId/adsets/:adsetId/ads/:adId", element: <AdCreativeDetail /> },
      { path: "cxo/action-board", element: <ComingSoonPage icon={ClipboardList} title="Action Board" /> },
      { path: "cxo/kpis/company-objectives", element: <ComingSoonPage icon={Target} title="Company Objectives" /> },
      { path: "cxo/kpis/team-targets", element: <ComingSoonPage icon={Target} title="Team Targets" /> },
      { path: "cxo/team-performance", element: <ComingSoonPage icon={TrendingUp} title="Team Performance" /> },
      { path: "cxo/reports", element: <ComingSoonPage icon={FileBarChart2} title="CXO Reports" /> },
      { path: "cxo/access-roles", element: <ComingSoonPage icon={ShieldCheck} title="Access & Roles" /> },
    ],
  },
];

export default AppRoutes;
